import type {
	ExtensionManifest,
	ExtensionModuleAction,
	Parameters,
} from '@atlaskit/editor-common/extensions';

import type { ExtensionSource } from './types';

export type CustomSitesManifestArguments<ParamsType> = {
	additionalModuleNodeProps?: Record<string, boolean>;
	description: string;
	icons: any;
	key: string;
	nodeType?: 'extension' | 'multiBodiedExtension' | 'inlineExtension' | 'bodiedExtension';
	parameters: ParamsType;
	quickInsertAction?: ExtensionModuleAction;
	render: any;
	setUpsellModalSource?: (source: ExtensionSource) => void;
	source: ExtensionSource;
	title: string;
	type: string;
	update: any;
};

export const getExtensionManifest = <ParamsType extends Parameters>({
	key,
	icons,
	parameters,
	update,
	render,
	title,
	type,
	description,
	source,
	nodeType = 'extension',
	quickInsertAction,
	setUpsellModalSource,
	additionalModuleNodeProps,
}: CustomSitesManifestArguments<ParamsType>): ExtensionManifest => {
	return {
		title,
		type,
		key,
		description,
		icons,
		modules: {
			quickInsert: setUpsellModalSource
				? [
						{
							key: 'quick-insert',
							action: async () => setUpsellModalSource(source),
						},
					]
				: [
						{
							key: 'quick-insert',
							action: quickInsertAction || {
								type: 'node',
								key: 'default',
								parameters,
							},
						},
					],
			nodes: {
				default: {
					type: nodeType,
					render,
					update,
					...additionalModuleNodeProps,
				},
			},
		},
	};
};
